export default "__VITE_ASSET__CjTDw4VZ__"